import { CommonKeys } from "../../../common/enums";
import { STAMM_TASK_TYPE } from "../../interfaces/stammelements/StammElementTask";

export const FormularGroupStammStammElementTaskSchema = {
    $id: "FormularGroupStammStammElementTaskSchema",
    title: "FormularGroupStammStammElementTask Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_TASK_TYPE },
                Property: { type: "number", nullable: true }
            }
        }
    ],
};